const cookie = require("../helpers/cookie");
module.exports = function(options) {

    let element;
    const _this = this;
    const events = require("../helpers/events");
    const cookie = require("../helpers/cookie");
    const ajax = require("../helpers/ajax");
    const cookieName = options.cookie || '';

    this.getElement = function () {
        return element;
    };

    this.logPreferenceChange = function(value) {
        if (options.logUrl) {
            return ajax.post(options.logUrl.replace(':value', value));
        }

        return new Promise(resolve => {
            resolve()
        })
    };

    this.disableToggle = function() {
        element.readOnly = true;
    };

    this.togglePreference = function(_event) {

        if (this.readOnly) {
            return false;
        }

        const selectedValue = this.checked ? '1' : '0';

        cookie.set(cookieName, selectedValue, 36500, '.adwantedconnected.com');

        _this.disableToggle();
        _this.logPreferenceChange(selectedValue)
            .finally(() => {
                location.reload();
            });
    };


    this.setBetaToggleActive = function() {
        //very rude solution
        if (cookie.get('publishing_remember_choice')) {
            return;
        }

        cookie.set(cookieName, '1', 36500, '.adwantedconnected.com');
        cookie.set('publishing_remember_choice', '1', 0.5, '.adwantedconnected.com');
        window.location.reload();
    }

    this.init = function(id) {
        element = document.getElementById(id);

        if (!element) {
            return;
        }

        this.setBetaToggleActive();

        events.addEvent(element, "change", _this.togglePreference);
    }
}
